export default "__VITE_ASSET__padcuOla__"